import { render, staticRenderFns } from "./BaseSampleComponent.vue?vue&type=template&id=b9636188&scoped=true&"
import script from "./BaseSampleComponent.vue?vue&type=script&lang=js&"
export * from "./BaseSampleComponent.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=b9636188&scoped=true&lang=css&"
import style1 from "./BaseSampleComponent.vue?vue&type=style&index=1&id=b9636188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9636188",
  null
  
)

export default component.exports